import React, { useState } from "react";
import Images from "../../src/assests/Images";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import visibilityoff from "../assests/visibility_off.png";
import visibilityon from "../assests/visibility_on.png";
import { companyData } from "../components/globalApi/Api";
const Login = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      roleBasedSelect: "admin",
    },
  });

  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(true);
  const [error, setError] = useState();

  const { roleBasedSelect } = watch();

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery(
    "company",
    companyData,
    {
      refetchOnWindowFocus: false,
    }
  );

  let details = (data && data?.data) || [];
  let singleObject = details[0] || {};
  console.log("singleObject", singleObject);

  // GET API END

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const url =
          roleBasedSelect == "admin"
            ? `${process.env.REACT_APP_HOST}/companies/login`
            : `${process.env.REACT_APP_HOST}/executives/login`;

        const response = await axios.post(url, postData);
        return response.data;
        // const response = await axios.post(
        //   `${process.env.REACT_APP_HOST}/companies/login`,
        //   postData
        // );
        // return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // Rethrow to trigger onError
      }
    },
    {
      onSuccess: (data) => {
        // console.log("data", data);
        sessionStorage.setItem("login", true);

        if (roleBasedSelect == "admin") {
          sessionStorage.setItem("rolebase", data && data?.company?.role);
          localStorage.setItem(
            "companyDetails",
            JSON.stringify(data && data?.company)
          );
        } else if (roleBasedSelect == "executive") {
          let exedata = (data && data?.executive) || {};
          sessionStorage.setItem("rolebase", exedata && exedata?.role);
          let companydata = (data && data?.companies[0]) || {};
          localStorage.setItem("companyDetails", JSON.stringify(companydata));
        }
        // window.location.reload();
        navigate("/");
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to login. Please try again.");
      },
    }
  );

  const onSubmit = (data) => {
    let formData = null;

    if (data?.roleBasedSelect === "admin") {
      formData = {
        username: data?.username,
        password: data?.password,
      };
    } else if (data?.roleBasedSelect === "executive") {
      formData = {
        phoneNumber: data?.phoneNumber,
        password: data?.password,
        shopName: singleObject?.shopName,
      };
    }

    if (formData) {
      mutate(formData);
    } else {
      alert("Please select a valid role and fill required fields.");
    }
  };

  return (
    <>
      <section className="loginMainSection">
        <Controller
          name="roleBasedSelect"
          control={control}
          defaultValue="admin"
          rules={{ required: "This field is required" }}
          render={({ field }) => (
            <>
              <select
                {...field}
                className="login_select_drop_down"
                style={{ position: "absolute", top: "10px", right: "10px" }}
              >
                <option value="">-- SELECT FLOW --</option>
                <option value="admin">Admin</option>
                <option value="executive">Executive</option>
              </select>
              {errors?.roleBasedSelect && (
                <p
                  style={{
                    color: "red",
                    fontSize: "18px",
                    position: "absolute",
                    top: "60px",
                    right: "20px",
                  }}
                >
                  {errors.roleBasedSelect.message}
                </p>
              )}
            </>
          )}
        />

        <div className="login_main_block">
          <div className="login_heading_block my-3">
            <div className="login_image_block">
              <img src={Images?.logo} alt="no-image" className="image_icon" />
            </div>
            <h5 className="login_heading">2K Inventry</h5>
          </div>
          <form className="my-3" onSubmit={handleSubmit(onSubmit)}>
            {roleBasedSelect == "admin" && (
              <>
                <div className="login_input_block">
                  <label className="login_label">Username</label>
                  <Controller
                    name="username"
                    control={control}
                    render={({ field }) => (
                      <input
                        type="email"
                        {...field}
                        className="login_input_field"
                      />
                    )}
                  />
                </div>
              </>
            )}
            {roleBasedSelect == "executive" && (
              <>
                <div className="login_input_block">
                  <label className="login_label">Username</label>
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field }) => (
                      <input
                        type="tel"
                        {...field}
                        className="login_input_field"
                      />
                    )}
                  />
                </div>
              </>
            )}

            <div className="login_input_block">
              <label className="login_label">Password</label>
              <div className="loginPasswordBlock">
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <input
                      type={`${!isShow ? "text" : "password"}`}
                      {...field}
                      className="login_password_field"
                    />
                  )}
                />
                <div
                  className="passwordBlock"
                  onClick={() => {
                    setIsShow(!isShow);
                  }}
                >
                  {!isShow ? (
                    <img
                      src={visibilityon}
                      style={{ width: "100%", height: "100%" }}
                      alt="no-image"
                    />
                  ) : (
                    <img
                      src={visibilityoff}
                      style={{ width: "100%", height: "100%" }}
                      alt="no-image"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="login_input_block my-4">
              <button className="login_btn">
                {postLoading ? (
                  <>
                    <i class="fa fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>Sign In</>
                )}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default Login;
